// src/pages/freevaluation/FreeValuationExpired.jsx
//
// Landing point when the magic link has expired, been used, or the
// token was tampered with. Same visual language as the landing so
// the recovery path is: paste your email again → get a new link.
//
// Route: /gratis-vardering/lank-utgangen (the backend verify
// endpoint redirects here on any token failure).

import React from "react";
import { Link } from "react-router-dom";
import "./freevaluation.css";

export default function FreeValuationExpired() {
  return (
    <div className="fv-page">
      <div className="fv-card">
        <h1>Länken har gått ut</h1>
        <p>
          Inloggningslänken var giltig i 30 minuter och kunde bara
          användas en gång. Ingen fara — vi skickar en ny så fort du
          fyller i din e-postadress igen.
        </p>
        <Link to="/gratis-vardering" className="fv-primary">
          Skicka en ny länk
        </Link>
      </div>
    </div>
  );
}
